//app.routes
import { Routes } from '@angular/router';
import { AuthGuard } from './../guards/auth.guard';

export const routes: Routes = [
 {
    path: 'sparten' as const,
    loadComponent: () =>
      import('./page-sparten/sparten-page.component').then(
        (c) => c.SpartenPageComponent
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./page-sparten/sparte-list/sparte-list.component').then(
            (c) => c.SparteListComponent
          ),
      },
    ],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./page-dashboard/dashboard-page.component').then(
        (c) => c.DashboardPageComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('./page-forbidden/page-forbidden.component').then(
        (c) => c.PageForbiddenComponent
      ),

  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/dashboard' },
];